import React, { useEffect, useState } from "react";
import { Box, Typography, Stack } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { fetchRevenuePlanWise } from "../../api/region";
import { useSelector } from "react-redux";

const RevenueChart = () => {
  const [revenueData, setRevenueData] = useState([]);
  const [totalRevenue, setTotalRevenue] = useState(0); 
  const [totalUsers, setTotalUsers] = useState(0); 
  const [isLoading, setIsLoading] = useState(true);
  const { filter } = useSelector((state) => state);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const data = await fetchRevenuePlanWise(filter);
      const totalRev = data.reduce((sum, d) => sum + d.totalRevenue, 0);
      const totalUsr = data.reduce((sum, d) => sum + d.subscriptionCount, 0);

      setTotalRevenue(totalRev);
      setTotalUsers(totalUsr);
      setRevenueData(data);
      setIsLoading(false);
    } catch (err) {
      console.error("Error while loading user data", err);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [JSON.stringify(filter)]);

  // Utility helpers
  const getValue = (type, field) =>
    revenueData.find((d) => d.subscriptionType === type)?.[field] || 0;

  // Revenues
  const goldRevenue = getValue("Gold", "totalRevenue");
  const luxuryRevenue = getValue("Luxury", "totalRevenue");
  const freeRevenue = getValue("Free", "totalRevenue"); // should be 0

  // Counts
  const goldCount = getValue("Gold", "subscriptionCount");
  const luxuryCount = getValue("Luxury", "subscriptionCount");
  const freeCount = getValue("Free", "subscriptionCount");

  // Percentages (based on count of users)
  const goldPercent = totalUsers ? (goldCount / totalUsers) * 100 : 0;
  const luxuryPercent = totalUsers ? (luxuryCount / totalUsers) * 100 : 0;
  const freePercent = totalUsers ? (freeCount / totalUsers) * 100 : 0;

  return (
    <Box
      p={2}
      sx={{
        boxShadow: "none",
        border: "1px solid #e6e6e6",
        borderRadius: "20px",
      }}
    >
      <Typography fontWeight="500" color="#3C4043" fontSize={20}>
        Revenue
      </Typography>
      {isLoading ?
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="body1" color="text.secondary">
            Loading...
          </Typography>
        </Box> :
        <>
      <Typography fontWeight="600" mt={1} mb={2} fontSize={24} color="#3C4043">
        ${totalRevenue.toLocaleString()}
      </Typography>

      {/* Progress Bar (user count ratio) */}
      <Box display="flex" width="100%" height={35} borderRadius={2} overflow="hidden">
        <Box width={`${goldPercent}%`} bgcolor="#b98908" />
        <Box width={`${luxuryPercent}%`} bgcolor="#3d73f1" />
        <Box width={`${freePercent}%`} bgcolor="#e0e0e0" />
      </Box>

      {/* Legend */}
      <Stack
        direction="row"
        spacing={3}
        mt={1}
        sx={{ textAlign: "center", justifyContent: "center" }}
      >
        <Typography sx={{ display: "flex", alignItems: "center", fontSize: 14, fontWeight: 500 }}>
          <FiberManualRecordIcon sx={{ fontSize: 15, color: "#CC9933" }} /> GOLD: ${goldRevenue.toLocaleString()} | {goldCount} Users ({goldPercent.toFixed(1)}%)
        </Typography>
        <Typography sx={{ display: "flex", alignItems: "center", fontSize: 14, fontWeight: 500 }}>
          <FiberManualRecordIcon sx={{ fontSize: 15, color: "#3361FF" }} /> Luxury: ${luxuryRevenue.toLocaleString()} | {luxuryCount} Users ({luxuryPercent.toFixed(1)}%)
        </Typography>
        <Typography sx={{ display: "flex", alignItems: "center", fontSize: 14, fontWeight: 500 }}>
          <FiberManualRecordIcon sx={{ fontSize: 15, color: "#F1F1F1" }} /> Free: ${freeRevenue.toLocaleString()} | {freeCount} Users ({freePercent.toFixed(1)}%)
        </Typography>
      </Stack>
        </>}
    </Box>
  );
};

export default RevenueChart;
